import { Copy, Pencil, Plus, Trash2 } from "lucide-react";
import { plural } from "./cargoSlots";

const btn = "inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-bold uppercase tracking-wider ring-1 ring-zinc-300 bg-white hover:bg-zinc-100 transition-colors";

export const TemplateBar = ({ templates, userId, value, onSelect, onNew, onEdit, onCopy, onDelete }) => {
  const mine = templates.filter((t) => t.owner_id === userId);
  const company = templates.filter((t) => !t.owner_id);
  const selected = templates.find((t) => t.id === value);
  const own = selected && selected.owner_id === userId;
  return (
    <div data-testid="loading-template-bar" className="rounded-2xl bg-white ring-1 ring-zinc-200 p-4 space-y-3">
      <label className="block text-xs font-semibold text-zinc-700">Reguły układania trasy
        <select data-testid="loading-template-select" value={value} onChange={(e) => onSelect(e.target.value)} className="mt-1 w-full rounded-xl border border-zinc-300 bg-white px-3 py-2.5 text-sm font-semibold focus:outline-none focus:border-orange-500">
          <option value="">Bez szablonu — kolejność wpisywania</option>
          {!!mine.length && <optgroup label="Moje szablony">{mine.map((t) => <option key={t.id} value={t.id}>{`${t.name} (${plural(t.rules.length, "reguła", "reguły", "reguł")})`}</option>)}</optgroup>}
          {!!company.length && <optgroup label="Szablony firmowe">{company.map((t) => <option key={t.id} value={t.id}>{`${t.name} (${plural(t.rules.length, "reguła", "reguły", "reguł")})`}</option>)}</optgroup>}
        </select>
      </label>
      <div className="flex flex-wrap gap-2">
        <button type="button" data-testid="loading-template-new" onClick={onNew} className={btn}><Plus className="w-3.5 h-3.5" />Mój szablon</button>
        {selected && !own && <button type="button" data-testid="loading-template-copy" onClick={onCopy} className={btn}><Copy className="w-3.5 h-3.5" />Kopiuj jako mój</button>}
        {own && <button type="button" data-testid="loading-template-edit" onClick={onEdit} className={btn}><Pencil className="w-3.5 h-3.5" />Edytuj</button>}
        {own && <button type="button" data-testid="loading-template-delete" onClick={onDelete} className={`${btn} text-red-600`}><Trash2 className="w-3.5 h-3.5" />Usuń</button>}
      </div>
    </div>
  );
};
